import React from 'react'

import { SvgIcon } from '@mui/material'

import DefaultLogo from './assets/logo.svg?react'

function Logo() {
  return (
    <SvgIcon
      viewBox='0 0 144 70'
      sx={{
        height: '70px',
        width: '120px',
      }}
      component={DefaultLogo}
    />
  )
}

export default React.memo(Logo)
